import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const Impersonate = () => {
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    // Helper to get query parameters
    const getQueryParams = () => {
        const params = new URLSearchParams(location.search);
        return {
            token: params.get('token'),
            type: params.get('type'),
        };
    };

    useEffect(() => {
        const { token, type } = getQueryParams();

        if (token && type) {
            // Case 1: Token and type are passed directly via query string
            localStorage.setItem('token', token);
            localStorage.setItem('user-type', type);
            navigate('/');
        }
    }, [id, location.search, navigate]);

    return (
        <div>
            <h1>Loading...</h1>
        </div>
    );
};

export default Impersonate;
